export default __webpack_public_path__ + "static/media/Lara.13ec6c29.png";